import { useRef, useState } from 'react'
import { Button_Main } from '../components/Button'
import Pagenation from '../components/Pagenation'
import Table from '../components/Table'
import { Main } from '../styles/layout'
import { Table_Info } from '../styles/table'
import { useGetPartList } from '../api/main'
import { useLocation } from 'react-router-dom'
import { Dialog } from '../components/Dialog'
import { PartCreateForm, PartUpdateForm } from '../components/Form'
import SearchForm, { DefaultParamKeys } from '../components/Search'
import { useAuthCheck } from '../hook'

export const PartPage = () => {
  const location = useLocation()
  const { checkAuth } = useAuthCheck()
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isUpdateOpen, setIsUpdateOpen] = useState(false)
  const [updateModalKey, setUpdateModalKey] = useState('')
  const { data, isLoading, isError } = useGetPartList(location.search)

  const openUpdateModal = (value:string) =>{
    setUpdateModalKey(value)
    setIsUpdateOpen(true)
  }
  return (
    <Main>
      <h1>소속 관리</h1>
      {checkAuth('1000') && <SearchForm searchList={searchList}/>}
      <Table_Info>
        Total Count: {data?.total}
        <Button_Main onClick={() => setIsCreateOpen(true)}>등록</Button_Main>
      </Table_Info>
      <Table headers={headers} data={data?.data} isLoading={isLoading} isError={isError} rowKey={headers[0].value} modalKey={"partId"} onClick={openUpdateModal}/>
      <Pagenation totalPage={data?.totalPage} isLoading={isLoading}/>

      <Dialog $isOpen={isCreateOpen} onClose={() => setIsCreateOpen(false)}>
        {isCreateOpen && <PartCreateForm onClose={() => setIsCreateOpen(false)} />}
      </Dialog>
      <Dialog $isOpen={isUpdateOpen} onClose={() => setIsUpdateOpen(false)}>
        {isUpdateOpen && <PartUpdateForm data={updateModalKey} onClose={() => setIsUpdateOpen(false)} />}
      </Dialog>
    </Main>
  )
}


const headers = [
  { value: 'partName', label: '소속' },
  { value: 'createdDate', label: '등록일' },
  { value: 'updatedDate', label: '수정일' },
  { value: 'partDesc', label: '비고' }
]

const searchList:DefaultParamKeys[] = [
  'partName',
]
